class ManageSkillsService {
    constructor($http, $q) {
        this.$http = $http;
        this.$q = $q;
    }

    getAllAreasData() {
        return this.$http({
            method: 'GET',
            url: '/api/subject_area',
            headers: {
                'Content-Type': 'application/json',
                'authentication': localStorage.getItem('kes_token'),
            },
            data: {},
        }).then((res => res.data), (error) => this.$q.reject(error));
    }

    saveArea(subjectArea) {
        return this.$http({
            method: 'POST',
            url: `/api/subject_area${subjectArea.id ? `/${subjectArea.id}` : ''}`,
            data: subjectArea,
            headers: {
                'Content-Type': 'application/json',
                'authentication': localStorage.getItem('kes_token'),
            },
        }).then((res => res.data), (error) => this.$q.reject(error));
    }

    getSkillsEvaluation(skill) {
        return this.$http({
            method: 'GET',
            url: `/api/skill/${skill.id}/evaluations`,
            headers: {
                'Content-Type': 'application/json',
                'authentication': localStorage.getItem('kes_token'),
            },
            data: {},
        }).then((res => res.data), (error) => this.$q.reject(error));
    }

    deleteArea(subjectArea) {
        return this.$http({
            method: 'DELETE',
            url: `/api/subject_area/${subjectArea.id}`,
            headers: {
                'Content-Type': 'application/json',
                'authentication': localStorage.getItem('kes_token'),
            },
        }).then((res => res.data), (error) => this.$q.reject(error));
    }

    saveAreaSubcategory(subcategory, subjectArea) {
        return this.$http({
            method: 'POST',
            url: `/api/subcategory${subcategory.id ? `/${subcategory.id}` : ''}`,
            data: Object.assign({}, subcategory, {
                subjectArea: subjectArea.id,
            }),
            headers: {
                'Content-Type': 'application/json',
                'authentication': localStorage.getItem('kes_token'),
            },
        }).then((res => res.data), (error) => this.$q.reject(error));
    }

    deleteAreaSubcategory(subcategory) {
        return this.$http({
            method: 'DELETE',
            url: `/api/subcategory/${subcategory.id}`,
            headers: {
                'Content-Type': 'application/json',
                'authentication': localStorage.getItem('kes_token'),
            },
        }).then((res => res.data), (error) => this.$q.reject(error));
    }

    getAreaSkills(subjectArea) {
        return this.$http({
            method: 'GET',
            url: `./api/subject_area/${subjectArea.id}`,
            headers: {
                'Content-Type': 'application/json',
                'authentication': localStorage.getItem('kes_token'),
            },
            data: {},
        }).then((res => res.data), (error) => this.$q.reject(error));
    }

    saveSkill(skill, grade) {
        return this.$http({
            method: 'POST',
            url: `/api/skill${skill.id ? `/${skill.id}` : ''}`,
            data: Object.assign({}, skill, {
                grade: grade.id,
            }),
            headers: {
                'Content-Type': 'application/json',
                'authentication': localStorage.getItem('kes_token'),
            },
        }).then((res => res.data), (error) => this.$q.reject(error));
    }

    deleteSkill(skill) {
        return this.$http({
            method: 'DELETE',
            url: `/api/skill/${skill.id}`,
            headers: {
                'Content-Type': 'application/json',
                'authentication': localStorage.getItem('kes_token'),
            },
        }).then((res => res.data), (error) => this.$q.reject(error));
    }
}

export default ManageSkillsService;



// WEBPACK FOOTER //
// ./src/app/pages/manageSkills/services/manageSkillsService.js